import { Stores } from "./Globals/Stores";

export class GlobalAppUrls {
    // CMR NEVER USE :id  make sure values are unique.
    public Client = {
        Account: {
            ForgotPassword: "/forgotpassword",
            ForgotPasswordSuccess: "/forgotpassword-success",
            Login: "/login",
            Logout: "/logout",
            ResetPassword: "/resetpassword",
            SessionExpired: "/sessionexpired",
        },

        Error: "/error",
        Home: "/",
        NotFound: "/notfound",
        PrivacyPolicy: "/privacy-policy",
        Terms: "/terms",
        // Test: "/test",

        Admin: {
            Root: "/admin",
            User: {
                Add: "/admin/user/add",
                Detail: "/admin/user/:userid",
                Edit: "/admin/user/:userid/edit",
                List: "/admin/user",
            },
            Client: {
                Add: "/admin/client/add",
                Detail: "/admin/client/:clientid",
                Edit: "/admin/client/:clientid/edit",
                List: "/admin/client",
            },
        },
        Approval: {
            List: "/approval",
            MyAmends: "/approval/myamends",
        },
        Central: {
            View: "/central/view/:ieid",
        },
        Induction: {
            List: "/inductionadminlist",
            View: "/inductionadmin/:inductionid/view",
            Index: "/induction/*",
            Landing: "/induction/landing",
            Step1: "/induction/step/1",
            Step2: "/induction/step/2",
            Step3: "/induction/step/3",
            Step4: "/induction/step/4",
            Step5: "/induction/step/5",
            Step6: "/induction/step/6",
            Submitted: "/induction/submitted/7",
            Access: {
                Index: "/induction/access/*",
                Landing: "/induction/access/landing/:projectId",
                SignedIn: "/induction/access/signedin/",
                Rams: "/induction/access/rams/:projectId",
                QR: "/induction/access/qr",
            },
        },
        Invoicing: {
            Add: "/invoice/add",
            AddIE: "/invoice/add/:ieid",
            Detail: "/invoice/:invoiceid",
            Edit: "/invoice/edit/:invoiceid/:approvalMode",
            EditIE: "/invoice/:ieid/edit/:invoiceid",
            List: "/invoice",
        },
        Project: {
            List: "/project",
            General: "/project/general/:projectid",
            GeneralAdd: "/project/add/general/",
            GeneralEdit: "/project/edit/general/:projectid",
            Commercial: "/project/commercial/:projectid",
            CommercialIEAdd: "/project/commercial/:projectid/add",
            CommercialIEEdit: "/project/commercial/:projectid/edit/:id",
            IE: "/project/ie/:ieid",
            Contractual: "/project/contractual/:projectid",
            ContractualEdit: "/project/edit/contractual/:projectid",
            Construction: "/project/construction/:projectid/main",
            ConstructionHAndS: "/project/construction/:projectid/hands",
            ConstructionQuality: "/project/construction/:projectid/quality",
            ConstructionEdit: "/project/edit/construction/:projectid",
            Delivery: "/project/delivery/:projectid",
            SiteAccess: "/project/siteaccess/:projectid",
            ProjectTrackers: "/project/projecttrackers/:projectid/main",
            DesignData: "/project/projecttrackers/:projectid/rdd",
            RequestForInformation: "/project/projecttrackers/:projectid/rfi",
            ReviewableDesignDataV2: "/project/projecttrackers/:projectid/rddV2",
            OutputTracker: {
                PlansOfWork: "/project/projecttrackers/:projectid/plansofwork",
                Outputs: "/project/projecttrackers/:projectid/plansofwork/:planofworkid/outputs",
                Drawings: {
                    List: "/project/projecttrackers/:projectid/plansofwork/:planofworkid/outputs/:outputid/drawings",
                    Edit: "/drawing/:drawingid/edit/:approvalMode",
                    View: "/drawing/:drawingid/view",
                },
            },
            QR: "/project/qr/:projectId/:displayName/:bitly",
            // Completed: "/project/completed/:projectid",
            IEItemFutureSpendAmendment: "/project/ie/:ieid/futurespendamendment/:ieitemid",
            IEItemRiskOpp: "/project/ie/:ieid/riskandopportunity/:ieitemid",
            VariationItemFutureSpendAmendment: "/project/ie/:ieid/variationfuturespendamendment/:variationid/:variationitemid",
            VariationItemRiskOpp: "/project/ie/:ieid/variationriskandopportunity/:variationid/:variationitemid",
            InductionUser: {
                Menu: "/project/inductionuser/menu",
                Permit: "/project/inductionuser/permit",
                Inspection: "/project/inductionuser/inspection",
                NearMiss: "/project/inductionuser/nearmiss",
                Scaffold: "/project/inductionuser/scaffold",
            },
            SiteTablet: {
                Menu: "/project/sitetablet/menu",
                Permit: "/project/sitetablet/permit",
                Inspection: "/project/sitetablet/inspection",
                NearMiss: "/project/sitetablet/nearmiss",
                Scaffold: "/project/sitetablet/scaffold",
            },
            Scaffolding: {
                Add: "/project/construction/:projectid/scaffolding/add",
                View: "/project/construction/:projectid/scaffolding/view/:scaffoldingId",
            },
            Permit: {
                Add: "/project/construction/:projectid/permit/add/:permitTypeId",
                View: "/project/construction/:projectid/permit/view/:permitId",
            },
            NonConformance: {
                Add: "/project/construction/:projectid/nonconformance/add/:nonConformanceTypeId",
                View: "/project/construction/:projectid/nonconformance/view/:nonConformanceId",
                HouseKeeping: {
                    Add: "/project/construction/:projectid/nonconformance/addHouseKeeping/:nonConformanceTypeId",
                    View: "/project/construction/:projectid/nonconformance/viewHouseKeeping/:nonConformanceId",
                },
                Discipline: {
                    Add: "/project/construction/:projectid/nonconformance/addDiscipline/:nonConformanceTypeId",
                    View: "/project/construction/:projectid/nonconformance/viewDiscipline/:nonConformanceId",
                },
                Quality: {
                    Add: "/project/construction/:projectid/nonconformance/addQuality/:nonConformanceTypeId",
                    View: "/project/construction/:projectid/nonconformance/viewQuality/:nonConformanceId",
                },
                Environment: {
                    Add: "/project/construction/:projectid/nonconformance/addEnvironment/:nonConformanceTypeId",
                    View: "/project/construction/:projectid/nonconformance/viewEnvironment/:nonConformanceId",
                },
            },
            Dilapidation: {
                Add: "/project/construction/:projectid/dilapidation/add/",
                View: "/project/construction/:projectid/dilapidation/view/:dilapidationReportId",
            },
            RAMSReview: {
                Add: "/project/construction/:projectid/ramsreview/add/",
                View: "/project/construction/:projectid/ramsreview/view/:ramsId",
            },
            Inspection: {
                Add: "/project/construction/:projectid/inspection/add/:inspectionTypeId",
                View: "/project/construction/:projectid/inspection/view/:inspectionId",
            },
            Incident: {
                //Add: "/project/construction/:projectid/incident/add/:incidentTypeId",
                View: "/project/construction/:projectid/incident/view/:incidentid",
                NearMiss: {
                    Add: "/project/construction/:projectid/incident/:incidentid/nearmiss/add",
                    View: "/project/construction/:projectid/incident/:incidentid/nearmiss/view/:incidentnearmissid",
                },
                WitnessStatement: {
                    Add: "/project/construction/:projectid/incident/:incidentid/witnessstatement/add",
                    View: "/project/construction/:projectid/incident/:incidentid/witnessstatement/view/:incidentwitnessstatementid",
                },
                Accident: {
                    Add: "/project/construction/:projectid/accident/:incidentid/accident/add",
                    View: "/project/construction/:projectid/accident/:incidentid/accident/view/:incidentaccidentid",
                },
            },
            ReviewableDesignData: {
                Add: "/project/projecttrackers/:projectid/designdata/add/:isdarwinrdd",
                AddWithReference: "/project/projecttrackers/:projectid/designdata/add/:isdarwinrdd/:ref",
                AddWithRevision: "/project/projecttrackers/:projectid/designdata/view/:designdataid/:isdarwinrdd/:isrevision",
                View: "/project/projecttrackers/:projectid/designdata/view/:designdataid/:isdarwinrdd",
            },
            RFI: {
                Add: "/project/projecttrackers/:projectid/rfi/add",
                AddWithReference: "/project/projecttrackers/:projectid/rfi/add/:ref",
                AddWithRevision: "/project/projecttrackers/:projectid/rfi/view/:rfiid/:isrevision",
                View: "/project/projecttrackers/:projectid/rfi/view/:rfiid",
            },
            RDDV2: {
                Add: "/project/projecttrackers/:projectid/rddV2/add",
                AddWithReference: "/project/projecttrackers/:projectid/rddV2/add/:ref",
                AddWithRevision: "/project/projecttrackers/:projectid/rddV2/view/:rddV2id/:isrevision",
                View: "/project/projecttrackers/:projectid/rddV2/view/:rddV2id",
            },
            //ReviewableDesignData
            ToolboxTalk: {
                Add: "/project/construction/:projectid/toolboxTalk/add",
                Edit: "/project/construction/:projectid/toolboxTalk/edit/:toolboxtalkid",
                View: "/project/construction/:projectid#toolbox",
            },
            ProgrammeUpdates: {
                BuildingControlSiteVisit: {
                    Add: "/project/construction/:projectid/programmeUpdates/buildingcontrolsitevisit/add/:date",
                },
            },
        },
        PurchaseOrder: {
            Add: "/po/add",
            AddIE: "/po/add/:projectid/:ie",
            Edit: "/po/:poid/edit/:approvalMode",
            View: "/po/:poid/view",
            List: "/po",
            RequisitionList: "/po/requisition",
            RejectedList: "/po/rejected",
        },
        Report: {
            //List: "/report",
            AllProject: "/report/allproject",
            Project: "/report/project",
            IE: "/report/ie",
        },
        Stock: {
            List: "/stock",
            MaterialList: "/stock/material",
            MaterialAdd: "/stock/material/add",
            StockHistory: "/stock/stockhistory",
        },
        Supplier: {
            Add: "/supplier/add",
            Detail: "/supplier/:supplierid",
            Edit: "/supplier/:supplierid/edit",
            List: "/supplier",
        },
        Variation: {
            Add: "/variation/add",
            AddIE: "/variation/add/:ieid",
            Edit: "/variation/:variationid/edit/:approvalMode",
            View: "/variation/:variationid/view",
        },
        Valuation: {
            Add: "/valuation/add/:poid",
            View: "/valuation/:valuationid/view",
        },
        ClientProvisionalSum: {
            Add: "/clientprovisionalsum/add",
            AddIE: "/clientprovisionalsum/add/:ieid",
            Edit: "/clientprovisionalsum/:variationid/edit/:approvalMode",
            View: "/clientprovisionalsum/:variationid/view",
        },
    };

    public Server = {
        Account: {
            Login: "/api/account/login",
            Logout: "/api/account/logout",
            ResetPassword: {
                Reset: "/api/account/resetpassword",
                VerifyToken: "/api/account/resetpasswordtoken",
            },

            ForgotPassword: "/api/account/forgotpassword",
            Register: "/api/account/register",
            SetPassword: "/api/account/setpassword",
        },
        Admin: {
            ResetFailedLoginAttemptsCount: "/api/user/ResetLoginAttempts",
            User: {
                GetAll: "/api/user/GetAll",
                GetDetails: "/api/user/GetUserDetails",
                GetUserRoles: "/api/user/GetUserRoles",
                Upsert: "/api/user/Upsert",
                IsEmailInUse: "/api/user/IsEmailInUse",
                Delete: "/api/user/DeleteUser",
            },
        },
        Approval: {
            DismissApprovalDelegate: "/api/approval/DismissApprovalDelegate",
            GetApprovalDelegateData: "/api/approval/GetApprovalDelegateAndRelatedByUserId",
            UpsertApprovalDelegation: "/api/approval/UpsertApprovalDelegation",
            SetDelegationsAsNotified: "/api/approval/SetDelegationsAsNotified",
            DeleteDelegations: "/api/approval/DeleteDelegations",
            GetRequisitionPOStatusCounts: "/api/approval/GetRequisitionPOStatusCounts",
            GetAllApprovalCounts: "/api/approval/GetAllApprovalCounts",
            GetApprovalCounts: "/api/approval/GetApprovalCounts",
            SearchMyApprovalsNew: "/api/approval/SearchMyApprovalsNew",
            SearchMyApprovalsActioned: "/api/approval/SearchMyApprovalsActioned",
            SearchMyAmends: "/api/approval/SearchMyAmends",
            GetAllRequisitionPOStatuses: "/api/approval/GetAllRequisitionPOStatuses",
            UpsertPurchaseOrderApprovalStatus: "/api/approval/UpsertPurchaseOrderApprovalStatus",
            UnrejectPurchaseOrder: "/api/approval/UnrejectPurchaseOrder",
            UpsertVariationApprovalStatus: "/api/approval/UpsertVariationApprovalStatus",
            UpsertInvoiceApprovalStatus: "/api/approval/UpsertInvoiceApprovalStatus",
            UpsertDrawingApprovalStatus: "/api/approval/UpsertDrawingApprovalStatus",
        },
        Central: {
            GetLatestCentralProjectView: "/api/project/GetLatestCentralProjectView",
            GetCentralProjectViewByProjectId: "/api/project/GetCentralProjectViewByProjectId",
        },
        Client: {
            GetAll: "/api/client/GetAll",
            GetDetails: "/api/client/GetClientDetails",
            Upsert: "/api/client/Upsert",
            GetClientContact: "/api/client/GetClientContact",
            UpsertContact: "/api/client/UpsertContact",
            DeleteContact: "/api/client/DeleteClientContact",
            UpdateClientContactIsPrimary: "/api/client/UpdateClientContactIsPrimary",
            IsReferenceInUse: "/api/client/IsReferenceInUse",
            GetClientNameAndId: "/api/client/GetClientNameAndId",
        },
        Invoice: {
            Upsert: "/api/invoice/UpsertInvoice",
            UpdateInvoiceDate: "/api/invoice/UpdateInvoiceDate",
            UpdateInvoiceAttachments: "/api/invoice/UpdateInvoiceAttachments",
            UpsertMatch: "/api/invoice/UpsertInvoiceMatch",
            UpsertMatchDraft: "/api/invoice/UpsertInvoiceMatchDraft",
            DisputeInvoice: "/api/invoice/DisputeInvoice",
            UpdateDisputedInvoiceStatusCode: "/api/invoice/UpdateInvoiceDisputedStatusCode",
            GetAllInvoiceRelated: "/api/invoice/GetAllInvoiceRelated",
            GetDateRelatedInvoice: "/api/invoice/GetDateRelatedInvoice",
            GenerateIEInvoiceListCSV: "/api/invoice/GenerateIEInvoiceListCSV",
            IsInvoiceNumberValid: "/api/invoice/IsInvoiceNumberValid",
            Load: {
                Related: "/api/invoice/GetRelated",
                WithRelatedById: "/api/invoice/GetWithRelatedById",
                GetFilteredPurchaseOrders: "/api/invoice/GetFilteredPurchaseOrders",
                GetFilteredProjects: "/api/invoice/GetFilteredProjects",
                InvoiceMatchById: "/api/invoice/GetInvoiceMatchById",
                InsertInvoicePurchaseOrder: "/api/invoice/InsertInvoicePurchaseOrder",
                DeleteInvoicePurchaseOrder: "/api/invoice/DeleteInvoicePurchaseOrder",
            },
            UpdateInvoiceStatus: "/api/invoice/UpdateInvoiceStatus",
            SetCanSendInvoiceEmailToSupplier: "/api/invoice/SetCanSendInvoiceEmailToSupplier",
            GenerateInvoiceListCSV: "/api/invoice/GenerateInvoiceListCSV",
        },
        Induction: {
            GetRelated: "/api/induction/GetRelated",
            GetRAMSsByProjectId: "/api/induction/GetRAMSByProjectId/:projectId",
            GetRAMSAttachmentsByRAMSId: "/api/induction/GetRAMSAttachmentsByRAMSId/:ramsId",
            SignIn: "/api/induction/SignInductionUserIn",
            SignOut: "/api/induction/SignInductionUserOut",
            GetInductionItemsRelated: "/api/induction/GetInductionItemsRelated",
            GetInductionDetailsById: "/api/induction/GetInductionDetailsById",
            Submit: "/api/induction/Submit",
            Delete: "/api/induction/DeleteInduction",
            Approve: "/api/induction/ApproveInduction",
            UpdateInductionStatus: "/api/induction/UpdateInductionStatus",
            GetInductionSiteAccessByInductionUserId: "/api/induction/GetSiteAccess",
            GenerateSiteAccessCSV: "/api/induction/GenerateSiteAccessCSV",
            UpdateInduction: "/api/induction/UpdateInduction",
            GetInductionScaffoldByInductionUserId: "/api/induction/GetInductionScaffoldByInductionUserId",
            GetInductionPermitsByInductionUserId: "/api/induction/GetInductionPermitsByInductionUserId",
            GetInductionIncidentFormNearMissByInductionUserId: "/api/induction/GetInductionIncidentFormNearMissByInductionUserId",
            GetInductionInspectionsByInductionUserId: "/api/induction/GetInductionInspectionsByInductionUserId",
            GetInductionNonConformanceByInductionUserId: "/api/induction/GetInductionNonConformanceByInductionUserId",
        },
        Roles: {
            GetAll: "/api/roles/getAll",
        },
        Projects: {
            Construction: {
                GetByProjectId: "/api/project/GetProjectConstruction",
                Upsert: "/api/project/UpsertProjectConstruction",
                Permit: {
                    Load: {
                        Related: "/api/permit/GetRelated",
                        WithRelatedById: "/api/permit/GetWithRelatedById",
                    },
                    Upsert: "/api/permit/Upsert",
                    LoadPermitsAndRelated: "/api/permit/GetPermitsAndRelated",
                },

                Inspections: {
                    LoadInspectionsAndRelated: "/api/project/GetProjectInspectionsAndRelated",
                    LoadQuestions: "/api/project/GetQuestionsByInspectionType",
                    LoadInspection: "/api/project/GetInspectionById",
                    UpsertInspection: "/api/project/UpsertInspection",
                },
                Audits: {
                    GetAuditQuestions: "/api/project/GetAuditQuestionsByAuditType",
                    GetEndOfDayAuditById: "/api/project/GetEndOfDayAuditById",
                    GetEndOfWeekAuditById: "/api/project/GetEndOfWeekAuditById",
                    GetAuditStatus: "/api/project/GetAuditStatus",
                    UpsertEndOfDayAudit: "/api/project/UpsertEndOfDayAudit",
                    UpsertEndOfWeekAudit: "/api/project/UpsertEndOfWeekAudit",
                    GetEndOfWeekAuditAndRelated: "/api/project/GetEndOfWeekAuditAndRelated",
                },
                ScaffoldInspection: {
                    GetProjectScaffoldList: "/api/project/GetProjectScaffoldList",
                    GetProjectScaffoldRelated: "/api/project/GetProjectScaffoldRelated",
                    GetProjectScaffoldWithRelated: "/api/project/GetProjectScaffoldWithRelated",
                    UpsertProjectScaffoldInspection: "/api/project/UpsertProjectScaffoldInspection",
                },
                NonConformance: {
                    GetNonConformanceAndRelated: "/api/nonconformance/GetNonConformanceAndRelated",
                    Load: {
                        Related: "/api/safety/GetRelated",
                        WithRelatedById: "/api/safety/GetWithRelatedById",
                    },
                    Upsert: "/api/safety/Upsert",
                    Housekeeping: {
                        Related: "/api/housekeeping/GetRelated",
                        WithRelatedById: "/api/housekeeping/GetWithRelatedById",
                        Upsert: "/api/housekeeping/Upsert",
                    },
                    Quality: {
                        Related: "/api/quality/GetRelated",
                        WithRelatedById: "/api/quality/GetWithRelatedById",
                        Upsert: "/api/quality/Upsert",
                    },
                    Environment: {
                        Related: "/api/environment/GetRelated",
                        WithRelatedById: "/api/environment/GetWithRelatedById",
                        Upsert: "/api/environment/Upsert",
                    },
                    Discipline: {
                        Related: "/api/discipline/GetRelated",
                        WithRelatedById: "/api/discipline/GetWithRelatedById",
                        Upsert: "/api/discipline/Upsert",
                    },
                },
                ProgrammeUpdates: {
                    UpsertProgrammeUpdateDocuments: "/api/project/UpsertProgrammeUpdateDocuments",
                    GetProgrammeUpdatesAndRelated: "/api/project/GetProgrammeUpdatesAndRelated",
                    UpsertBuildingControl: "/api/project/UpsertBuildingControl",
                    GetBuildingControlSiteVisitAndRelatedByProjectId: "/api/project/GetBuildingControlSiteVisitAndRelatedByProjectId",
                    CleanlinessReport: {
                        UpsertCleanlinessReport: "/api/project/UpsertCleanlinessReport",
                        GetCleanlinessReportAndRelatedById: "/api/project/GetCleanlinessReportAndRelatedById",
                    },
                    WeatherReport: {
                        UpsertCustomerVisitsSiteInstructions: "/api/project/UpsertWeatherReport",
                        GetCustomerVisitsSiteInstructionsAndRelatedByProjectId: "/api/project/GetWeatherReportAndRelatedByProjectIdAndDate",
                    },
                    NonConformance: {
                        GetNonConformanceListByDate: "/api/project/GetNonConformanceListByDate",
                    },
                    TestAndInspections: {
                        GetTestAndInspectionsListByDate: "/api/project/GetTestAndInspectionListByDate",
                    },
                    CustomerVisitsSiteInstructions: {
                        UpsertCustomerVisitsSiteInstructions: "/api/project/UpsertCustomerVisitsSiteInstructions",
                        GetCustomerVisitsSiteInstructionsAndRelatedByProjectId: "/api/project/GetCustomerVisitsSiteInstructionsAndRelatedByProjectId",
                        GetVisitorsListByDate: "/api/project/GetVisitorsListByDate",
                    },
                    DailyProgrammeProgressUpdate: {
                        UpsertDailyProgrammeProgressUpdate: "/api/project/UpsertDailyProgrammeProgressUpdate",
                        GetDailyProgrammeProgressUpdateAndRelatedByProjectId: "/api/project/GetDailyProgrammeProgressUpdateAndRelatedByProjectId",
                    },
                    DailyProgrammeProgressUpdateV2: {
                        UpsertDailyProgrammeProgressUpdateV2: "/api/project/UpsertDailyProgrammeProgressUpdateV2",
                        GetDailyProgrammeProgressUpdateV2AndRelatedById: "/api/project/GetDailyProgrammeProgressUpdateV2AndRelatedById",
                    },
                    OtherProgrammeNotes: {
                        UpsertOtherProgrammeNotes: "/api/project/UpsertOtherProgrammeNotes",
                        GetOtherProgrammeNotesAndRelatedByProjectId: "/api/project/GetOtherProgrammeNotesAndRelatedByProjectId",
                    },
                    PotentialProgrammeDelays: {
                        GetPotentialProgrammeDelaysAndRelatedById: "/api/project/GetPotentialProgrammeDelaysAndRelatedById",
                        UpsertPotentialProgrammeDelays: "/api/project/UpsertPotentialProgrammeDelays",
                    },
                    OutstandingDesignInformation: {
                        GetOutstandingDesignInformationAndRelatedById: "/api/project/GetOutstandingDesignInformationAndRelatedById",
                        UpsertOutstandingDesignInformation: "/api/project/UpsertOutstandingDesignInformation",
                    },
                    MaterialStorage: {
                        GetMaterialStorageAndRelatedById: "/api/project/GetMaterialStorageAndRelatedById",
                        UpsertMaterialStorage: "/api/project/UpsertMaterialStorage",
                    },
                    LabourShortage: {
                        GetLabourShortageAndRelatedById: "/api/project/GetLabourShortageAndRelatedById",
                        UpsertLabourShortage: "/api/project/UpsertLabourShortage",
                    },
                },
                Dilapidation: {
                    GetDilapidationList: "/api/dilapidation/GetDilapidationList",
                    GetDilapidationAndRelated: "/api/dilapidation/GetDilapidationAndRelated",
                    GetDilapidationRelated: "/api/dilapidation/GetDilapidationRelated",
                    Upsert: "/api/dilapidation/Upsert",
                },
                Rams: {
                    GetRAMSAndRelated: "/api/rams/GetRamsAndRelated",
                    GetRAMSAndRelatedById: "/api/rams/GetRamsWithRelatedById",
                    GetRAMSRelated: "/api/rams/GetRamsRelated",
                    UpsertRAMSForm: "/api/rams/upsert",
                },
                Incident: {
                    Load: {
                        WithRelatedById: "/api/incident/GetWithRelatedById",
                    },
                    Upsert: "/api/incident/Upsert",
                    LoadIncidentsAndRelated: "/api/incident/GetIncidentsAndRelated",
                    NearMiss: {
                        Load: {
                            Related: "/api/incident/GetNearMissRelated",
                            WithRelatedById: "/api/incident/GetNearMissWithRelatedById",
                        },
                        Upsert: "/api/incident/UpsertIncidentFormNearMiss",
                    },
                    WitnessStatement: {
                        Load: {
                            Related: "/api/incident/GetWitnessStatementRelated",
                            WithRelatedById: "/api/incident/GetWitnessStatementWithRelatedById",
                        },
                        Upsert: "/api/incident/UpsertIncidentFormWitnessStatement",
                    },
                    Accident: {
                        Load: {
                            Related: "/api/incident/GetAccidentRelated",
                            WithRelatedById: "/api/incident/GetAccidentWithRelatedById",
                            GetCasualtyUserDetails: "/api/incident/GetIncidentAccidentCasualtyUserDetails",
                        },
                        Upsert: "/api/incident/UpsertIncidentFormAccident",
                    },
                },
                ToolboxTalk: {
                    Load: {
                        Related: "/api/toolboxtalk/GetToolboxTalkRelated",
                        WithRelatedById: "/api/toolboxtalk/GetWithRelatedById",
                    },
                    Upsert: "/api/toolboxtalk/Upsert",
                    LoadToolboxTalksAndRelated: "/api/toolboxtalk/GetToolboxTalksAndRelated",
                },
                DailyDiary: {
                    Load: "/api/project/GetDailyDiary",
                    Upsert: "/api/project/UpsertDailyDiary",
                    Submit: "/api/project/SubmitDailyDiary",
                },
            },
            Contractual: {
                GetByProjectId: "/api/project/GetProjectContractual",
                Upsert: "/api/project/UpsertProjectContractual",
            },
            ProjectTrackers: {
                DesignData: {
                    ExportRDDList: "/api/designdata/DesignDataListCSV",
                    GetDesignDataList: "/api/designdata/GetDesignDataList",
                    GetDesignDataAndRelated: "/api/designdata/GetDesignDataAndRelated",
                    GetDesignDataRelated: "/api/designdata/GetDesignDataRelated",
                    Upsert: "/api/designdata/Upsert",
                    UpdateStatus: "/api/designdata/UpdateStatus",
                    GetDesignDataResponseById: "/api/designdata/GetDesignDataResponseById",
                    UpsertDesignDataResponse: "/api/designdata/UpsertDesignDataResponse",
                    GetDesignDataItemsById: "/api/designdata/GetDesignDataItemsById",
                    GetDesignDataFilesById: "/api/designdata/GetDesignDataFilesById",
                },
                RFI: {
                    ExportRFIList: "/api/rfi/RFIListCSV",
                    GetRFIList: "/api/rfi/GetRFIList",
                    GetRFIAndRelated: "/api/rfi/GetRFIAndRelated",
                    GetRFIRelated: "/api/rfi/GetRFIRelated",
                    Upsert: "/api/rfi/Upsert",
                    UpdateStatus: "/api/rfi/UpdateStatus",
                    GetRFIResponseById: "/api/rfi/GetRFIResponseById",
                    UpsertRFIResponse: "/api/rfi/UpsertRFIResponse",
                    GetRFIItemsById: "/api/rfi/GetRFIItemsById",
                    GetRFIFilesById: "/api/rfi/GetRFIFilesById",
                    Create: "/api/rfi/Create",
                    IssueRelatedByRFIIds: "/api/rfi/GetIssueRelatedByRFIIds",
                    IssueRFIs: "/api/rfi/IssueRFIs",
                },
                RDDV2: {
                    ExportRDDV2List: "/api/rddV2/RDDV2ListCSV",
                    GetRDDV2List: "/api/rddV2/GetRDDV2List",
                    GetRDDV2AndRelated: "/api/rddV2/GetRDDV2AndRelated",
                    GetRDDV2Related: "/api/rddV2/GetRDDV2Related",
                    Upsert: "/api/rddV2/Upsert",
                    UpdateStatus: "/api/rddV2/UpdateStatus",
                    GetRDDV2ResponseById: "/api/rddV2/GetRDDV2ResponseById",
                    UpsertRDDV2Response: "/api/rddV2/UpsertRDDV2Response",
                    GetRDDV2ItemsById: "/api/rddV2/GetRDDV2ItemsById",
                    GetRDDV2FilesById: "/api/rddV2/GetRDDV2FilesById",
                    Create: "/api/rddV2/Create",
                    IssueRelatedByRDDV2Ids: "/api/rddV2/GetIssueRelatedByRDDV2Ids",
                    IssueRDDV2s: "/api/rddV2/IssueRDDV2s",
                },
                OutputTracker: {
                    PlansOfWork: {
                        GetByProjectId: "/api/planofwork/getviewsbyprojectid/{projectid}",
                        Related: "/api/planofwork/getrelated/{projectid}",
                        Insert: "/api/planofwork/insert/{projectid}",
                        GetDrawings: "/api/planofwork/GetDrawingsByPlanOfWorkId/{planOfWorkId}",
                        CreateCopy: "/api/planofwork/createcopy",
                    },
                    Outputs: {
                        GetByPlanOfWorkId: "/api/output/getviewsbyplanofworkid/{planofworkid}",
                        IssueRelatedByOutputIds: "/api/output/getissuerelatedbyoutputids",
                        IssueDrawings: "/api/output/issuedrawings",
                        Related: "/api/output/getrelated",
                        WithRelated: "/api/output/getwithrelatedbyid/{outputid}",
                        Upsert: "/api/output/upsert",
                        GenerateOutputTrackerPDF: "/api/output/GenerateOutputTrackerPDF",
                    },
                    Drawings: {
                        GetByOutputId: "/api/drawing/getviewsbyoutputid/{outputid}",
                        GetHistoryByOutputId: "/api/drawing/getdrawinghistoryviewsbyoutputid/{outputid}",
                        GetDrawingsOnlyByOutputId: "/api/drawing/getdrawingonlyviewsbyoutputid/{outputid}",
                        GetDrawing: "/api/drawing/getdrawing/{drawingid}",
                        WithRelated: "/api/drawing/getwithrelatedbyid/{drawingid}",
                        Insert: "/api/drawing/insert/{outputid}",
                        Update: "/api/drawing/update/{drawingid}",
                        Amend: "/api/drawing/amend/{drawingid}",
                        AutodeskCloudAPI: {
                            GetProjectTopFolders: "/api/autodesk/GetProjectTopFolders/{projectId}",
                            GetFolderContents: "/api/autodesk/GetFolderContents/{projectId}/{folderId}",
                            GetItemTip: "/api/autodesk/GetItemTip/{projectId}/{itemId}",
                            GetItemDownloadUrl: "/api/autodesk/GetItemDownloadUrl/{drawingId}/{versionId}",
                            GetItemDownloadUrl2: "/api/autodesk/GetItemDownloadUrl2/{drawingId}/{versionId}/{fileName}",
                            GetItemDownload: "/api/autodesk/GetItemDownload/{drawingId}/{versionId}/{fileName}",
                        },
                    },
                },
            },
            SiteAccess: {
                GetProjectSiteAccessById: "/api/induction/GetProjectSiteAccess",
                ForceInductionsSignOut: "/api/induction/ForceInductionsSignOut",
                GenerateProjectSiteAccessCSV: "/api/induction/GenerateProjectSiteAccessCSV",
                UpdateSiteVideoLink: "/api/induction/UpdateSiteVideoLink",
            },
            GetAll: "/api/project/GetAll",
            GetAllUsers: "/api/project/GetAllUsers",
            GetAllAndRelated: "/api/project/GetAllAndRelated",
            GetProjectListItems: "/api/project/GetProjectListItems",
            GetDetails: "/api/project/GetProjectDetails",
            GetProjectDetailsByUserId: "/api/project/GetUserDetailsWithProject",
            GetProjectInspectionTypes: "/api/project/GetProjectInspectionTypes",
            GetPermitTypes: "/api/permit/getpermittypes",
            GetRelated: "/api/project/GetProjectRelated",
            Commercial: {
                GetIECommercial: "/api/ie/GetIECommercialView",
            },
            IncomeExpend: {
                DeleteIE: "/api/ie/DeleteIE",
                GetDeleteIE: "/api/ie/GetDeleteIE",
                GetEditIERelated: "/api/ie/GetEditIERelated",
                GetEditIEAndRelated: "/api/ie/GetEditIEAndRelated",
                UpsertIE: "/api/ie/UpsertIE",
                GetCategories: "/api/ie/GetAllProjectCategories",
                GetIEandRelated: "/api/ie/GetIEandRelated",
                GetIEView: "/api/ie/GetIEView",
                GenerateIEViewCSV: "/api/ie/GenerateIEViewCSV",
                UpsertIECategory: "/api/ie/UpsertIECategory",
                UpsertIESubCategory: "/api/ie/UpsertIESubcategory",
                UpsertIELine: "/api/ie/UpsertIEItemLine",
                DeleteIELine: "/api/ie/DeleteIEItemLine",
                UpsertItem: "/api/ie/UpsertItem",
                GetRequisitionsList: "/api/ie/GetRequisitionsList",
                GetPurchaseOrderList: "/api/ie/GetPurchaseOrderList",
                GeneratePurchaseOrderListCSV: "/api/ie/GeneratePurchaseOrderListCSV",
                GetIEFutureSpendAmendmentAndRelated: "/api/ie/GetIEFutureSpendAmendmentAndRelated",
                UpsertFutureSpendAmendment: "/api/ie/UpsertFutureSpendAmendment",
                GetIERiskOppAndRelated: "/api/ie/GetIERiskOppAndRelated",
                UpsertRiskOpp: "/api/ie/UpsertriskOpp",
            },

            Upsert: "/api/project/Upsert",
            IsReferenceInUse: "/api/project/IsReferenceInUse",
            UploadDocument: "/api/project/UploadDocument",
            UploadProjectNote: "/api/project/UploadProjectNote",
            UpsertUserProjectFavourite: "/api/project/UpsertUserProjectFavourite",
            UpsertProjectDirectoryPerson: "/api/project/UpsertProjectDirectoryPerson",
            DeleteProjectDirectoryPerson: "/api/project/DeleteProjectDirectoryPerson",
        },
        Stock: {
            DownloadStockViews: "/api/stock/downloadstockviews",
            GetStockForTransferWithRelatedByMaterialId: "/api/stock/getstockfortransferwithrelatedbymaterialid/{materialid}",
            GetStockViews: "/api/stock/getstockviews",
            GetStockHistoryViewsByMaterialId: "api/stock/getstockhistoryviewsbymaterialid/{materialid}",
            DownloadStockHistoryViews: "/api/stock/downloadstockhistoryviews",
            GetStockHistoryViews: "api/stock/getstockhistoryviews",
            GetStockTransferHistoryViewsByIEItemMaterialId: "api/stock/getstocktransferhistoryviewsbyieitemmaterialid/{ieItemMaterialId}",

            GetUnitsAndCostsForAdjustment: "/api/stock/getunitsandcostsforadjustment/{materialid}/{units}",
            GetUnitsAndCostsForTransfer: "/api/stock/getunitsandcostsfortransfer/{materialid}/{units}/{transactiontypeid}/{ieitemid}",

            GetIncomeAndExpendituresByProjectId: "/api/stock/getincomeandexpendituresbyprojectid/{projectid}",
            GetCategoriesByIncomeAndExpenditureId: "/api/stock/getcategoriesbyincomeandexpenditureid/{incomeandexpenditureid}",
            GetSubCategoriesByCategoryId: "/api/stock/getsubcategoriesbycategoryid/{categoryid}",
            GetLineDescriptionsBySubCategoryId: "/api/stock/getlinedescriptionsbysubcategoryid/{subcategoryid}",

            RequestAdjustStock: "/api/stock/requestadjuststock/{materialid}",
            RequestTransferStock: "api/stock/requesttransferstock/{materialid}",

            GetStockTransactionRequestViewByStockTransactionRequestId: "/api/stock/getstocktransactionrequestviewbystocktransactionrequestid/{stocktransactionrequestid}",
            AdjustStock: "/api/stock/adjuststock/{stocktransactionrequestid}",
            TransferStock: "/api/stock/transferstock/{stocktransactionrequestid}",

            Material: {
                DownloadMaterialViews: "/api/material/downloadmaterialviews",
                GetMaterialDetailsWithRelatedByMaterialId: "/api/material/getmaterialdetailswithrelatedbymaterialid/{materialid}",
                GetMaterialPriceDetailsViewsByMaterialId: "/api/material/getmaterialpricedetailsviewsbymaterialid/{materialid}",
                GetMaterialPriceDetailsWithRelatedByMaterialId: "/api/material/getmaterialpricedetailswithrelatedbymaterialid/{materialid}",
                GetMaterialRelated: "/api/material/getmaterialrelated",
                GetMaterialViews: "/api/material/getmaterialviews",

                RequestCreateMaterial: "/api/material/requestcreatematerial",
                RequestUpdateMaterialPriceDetails: "/api/material/requestupdatematerialpricedetails/{materialid}",

                UpdateMaterialDetails: "/api/material/updatematerialdetails/{materialid}",

                GetMaterialTransactionRequestViewByMaterialTransactionRequestId:
                    "/api/material/getmaterialtransactionrequestviewbymaterialtransactionrequestid/{materialtransactionrequestid}",
                CreateMaterial: "/api/material/creatematerial/{materialtransactionrequestid}",
                UpdateMaterialPriceDetails: "/api/material/updatematerialpricedetails/{materialtransactionrequestid}",
            },
        },
        Supplier: {
            GetAll: "/api/supplier/GetAll",
            GetDetails: "/api/supplier/GetSupplierDetails",
            GetContactType: "/api/supplier/GetContactType",
            Upsert: "/api/supplier/Upsert",
            GetSupplierContact: "/api/supplier/GetSupplierContact",
            UpsertContact: "/api/supplier/UpsertContact",
            DeleteContact: "/api/supplier/DeleteSupplierContact",
            UpdateSupplierContactIsPrimary: "/api/supplier/UpdateSupplierContactIsPrimary",
            IsReferenceInUse: "/api/supplier/IsReferenceInUse",
            UpdateSupplierStatus: "/api/supplier/UpdateSupplierStatus",
        },
        PurchaseOrder: {
            GetAll: "/api/purchaseorder/GetAll",
            GetAllWithFilters: "/api/purchaseorder/GetAllWithFilters",
            CanVoidOrderLine: "/api/requisitionrequest/CanVoidOrderLine/{orderLineId}",
            GetAllRequisitionList: "/api/requisitionrequest/GetAllRequisitionList",
            GetSupplierDetailBySupplierId: "/api/requisitionrequest/GetSupplierDetailBySupplierId",
            GetIsDuplicateRequisitionSupplierOnIE: "/api/requisitionrequest/GetIsDuplicateRequisitionSupplierOnIE",
            GetAddressesByProjectId: "/api/requisitionrequest/GetAddressesByProjectId",
            GetIEByProjectId: "/api/requisitionrequest/GetIEByProjectId",
            GetVariationsByIEId: "/api/requisitionrequest/GetVariationsByIEId",
            GetIECategoryByIEId: "/api/requisitionrequest/GetIECategoryByIEId",
            GetIESubcategoryByCatId: "/api/requisitionrequest/GetIESubcategoryByCatId",
            GetIELineItemsBySubcategoryId: "/api/requisitionrequest/GetIELineItemsBySubcategoryId",
            GetMaterialsBySupplierId: "/api/requisitionrequest/GetMaterialsBySupplierId",
            GetBudgetCosts: "/api/requisitionrequest/GetBudgetCosts",
            Load: {
                Related: "/api/requisitionrequest/GetRelated",
                WithRelatedById: "/api/requisitionrequest/GetWithRelatedById",
            },
            Upsert: "/api/requisitionrequest/UpsertRequisition",
            AmendRequisition: "/api/requisitionrequest/AmendRequisition",
            ReviseRequisition: "/api/requisitionrequest/ReviseRequisition",
            SaveRequisitionNote: "/api/requisitionrequest/SaveRequisitionNote",
            //Unreject: "/api/requisitionrequest/UnrejectRequisition",
            GeneratePOPDFById: "/api/exportpdf/GeneratePOPDFById",
            GeneratePOPDFPreviewById: "/api/exportpdf/GeneratePOPDFPreviewById",
            GeneratePOPDFByIdAndRevision: "/api/exportpdf/GeneratePOPDFByIdAndRevision",
            GeneratePOPDFByIdV2: "/api/requisitionrequest/GeneratePOPDFByIdV2",
            GetLineIdMatchingExistingRequisition: "/api/requisitionrequest/GetLineIdMatchingExistingRequisition",
            SendSupplierEmail: "/api/requisitionrequest/SendPOApprovedEmail",
            ValidateRequisitionDocuments: "/api/requisitionrequest/ValidateRequisitionDocuments",
            GetCatsSubCatsAndLineIdsByPOId: "/api/requisitionrequest/GetCatsSubCatsAndLineIdsByPOId",
            GeneratePurchaseOrderListCSV: "/api/purchaseorder/GeneratePurchaseOrderListCSV",
            UpdateCentralRequisitionGroup: "/api/requisitionrequest/UpdateCentralRequisitionGroup",
        },
        Variation: {
            Upsert: "/api/variation/UpsertVariation",
            Delete: "/api/variation/DeleteVariation",
            GetVariationList: "/api/variation/GetVariationList",
            GetApprovedVariationList: "/api/variation/GetApprovedVariationList",
            GenerateIEVariationListCSV: "api/variation/GenerateIEVariationListCSV",
            GetVarianceView: "/api/variation/GetVarianceView",
            Load: {
                Related: "/api/variation/GetRelated",
                WithRelatedById: "/api/variation/GetWithRelatedById",
            },
            //AmendVariation: "/api/variation/AmendVariation",
            GenerateVOPDFById: "/api/exportpdf/GenerateVariationPDFById",
            GetVariationRiskOppAmendmentAndRelated: "/api/variation/GetVariationRiskOppAmendmentAndRelated",
            UpsertRiskOppAmendment: "/api/variation/UpsertRiskOppAmendment",
            GetVariationFutureSpendAmendmentAndRelated: "/api/variation/GetVariationFutureSpendAmendmentAndRelated",
            UpsertVariationFutureSpendAmendment: "/api/variation/UpsertVariationFutureSpendAmendment",
            ReviseVariation: "/api/variation/ReviseVariation",
            CanReviseVariation: "/api/variation/CanReviseVariation",
            GetRejectedVariationsList: "/api/variation/GetRejectedVariationsList",
            GetRejectedCPSList: "/api/variation/GetRejectedCPSList",
            SendVariationApprovedEmail: "/api/variation/SendVariationApprovedEmail",
            ValidateVariationDocuments: "/api/variation/ValidateVariationDocuments",
        },
        Valuation: {
            GetValuationRelated: "/api/valuation/GetValuationRelated/{ieId}",
            GetNewValuationDetails: "/api/valuation/GetNewValuationDetails/{poId}",
            GetValuationDetailsById: "/api/valuation/GetValuationDetailsById/{id}",
            CreateValuation: "/api/valuation/CreateValuation/{poId}",
            UpdateValuation: "/api/valuation/UpdateValuation/{id}",
            DeleteValuation: "/api/valuation/DeleteValuation/{id}",
            GetValuationGrid: "/api/valuation/GetValuationGrid/{ieId}",
        },
        File: {
            UploadFile: "/api/upload/UploadFile",
            DownloadFile: "/api/upload/downloadfile",
        },
        Report: {
            LoadRelated: "/api/report/GetRelated",
            AllProjects: {
                GetProjectsReport: "/api/report/GetAllProjectsReport",
                GetAllProjectsCVRReport: "/api/report/GetAllProjectsCVRReport",
                GetAllProjectsCostReport: "/api/report/GetAllProjectsCostReport",
                GenerateAllProjectsCVRReportCSV: "/api/report/GenerateAllProjectsCVRReportCSV",
                GenerateAllProjectsCostReportCSV: "/api/report/GenerateAllProjectsCostReportCSV",
                GenerateAllProjectsReportCSV: "/api/report/GenerateAllProjectsReportCSV",
                GetAllProjectsInvoiceReport: "/api/report/GetAllProjectsInvoiceReport",
                GenerateAllProjectsInvoiceReportCSV: "/api/report/GenerateAllProjectsInvoiceReportCSV",
                GetAllProjectsApprovedInvoicesReport: "/api/report/GetAllProjectsApprovedInvoicesReport",
                GenerateAllProjectsApprovedInvoicesReportCSV: "/api/report/GenerateAllProjectsApprovedInvoicesReportCSV",
                LoadRelated: "/api/report/GetAllProjectsRelated",
            },
            Project: {
                GetProjectReport: "/api/report/GetProjectReport",
                GetProjectCVRReport: "/api/report/GetProjectCVRReport",
                GetProjectCostReport: "/api/report/GetProjectCostReport",
                GenerateProjectCVRReportCSV: "/api/report/GenerateProjectCVRReportCSV",
                GenerateProjectCostReportCSV: "/api/report/GenerateProjectCostReportCSV",
                GenerateProjectReportCSV: "/api/report/GenerateProjectReportCSV",
                GetProjectInvoiceReport: "/api/report/GetProjectInvoiceReport",
                GenerateProjectInvoiceReportCSV: "/api/report/GenerateProjectInvoiceReportCSV",
            },
            IE: {
                GetIEReport: "/api/report/GetIEReport",
                GenerateIEReportCSV: "/api/report/GenerateIEReportCSV",
                GetIECVRReport: "/api/report/GetIECVRReport",
                GetIECostReport: "/api/report/GetIECostReport",
                GenerateIECVRReportCSV: "/api/report/GenerateIECVRReportCSV",
                GenerateIECostReportCSV: "/api/report/GenerateIECostReportCSV",
                GetIEHireTrackerReport: "/api/report/GetHireTrackerReport",
                GenerateIEHireTrackerReportCSV: "/api/report/GenerateHireTrackerReportCSV",
                UpsertItemHireInformation: "/api/requisitionrequest/UpdateRequisitionRequestItemHire",
            },
        },
        Hubs: {
            ApprovalHub: "/hubs/approvalhub",
        },
    };
}

export const AppUrls = new GlobalAppUrls();
